import type { HTMLComponent } from "@commercekit/react";
import { useLocalePath } from "@commercekit/remix";
import WvLink from "./WvLink";
import type { Breadcrumb } from "@commercekit/api";

const WvBreadcrumbs: HTMLComponent<{
  breadcrumbs: Breadcrumb[];
  mobileMarginBottom?: string;
  account?: boolean;
}> = ({ breadcrumbs, mobileMarginBottom, account }) => {
  const localePath = useLocalePath();

  const lastPath = breadcrumbs[breadcrumbs.length - 1];
  const immediatePath = breadcrumbs[breadcrumbs.length - 2];

  const mobileBreadcrumbs =
    breadcrumbs.length > 3
      ? [
          ...breadcrumbs.slice(
            breadcrumbs.length > 2 ? breadcrumbs.length - 3 : 0,
            breadcrumbs.length - 1
          ),
        ]
      : [...breadcrumbs.slice(0, breadcrumbs.length - 1)];

  return (
    <>
      <div className="breadcrumbs py-3">
        {breadcrumbs &&
          breadcrumbs.map((breadcrumb, index) =>
            lastPath.id === breadcrumb.id ? (
              <span key={breadcrumb?.id + index}>{breadcrumb.name}</span>
            ) : (
              <WvLink
                to={localePath(`/${breadcrumb.path}`)}
                className={`${
                  breadcrumb.id === immediatePath?.id ? "mobile" : ""
                } ${index === 0 ? "first" : ""} category`}
                data-icon-before=""
                key={breadcrumb?.id + index}
              >
                <i
                  className={`${
                    breadcrumb.id === immediatePath?.id ? "mobile" : ""
                  } d-lg-none`}
                  data-icon-before=""
                  key={breadcrumb.id + index}
                >
                  {" "}
                </i>
                {breadcrumb.name}
                <i data-icon-after=""></i>
              </WvLink>
            )
          )}
      </div>

      <div
        className="mobile-breadcrumbs mt-3"
        style={{ marginBottom: mobileMarginBottom ?? "12px" }}
      >
        {account && lastPath?.name ? (
          <span data-icon-before="">{lastPath.name}</span>
        ) : null}
        {mobileBreadcrumbs.length ? (
          <>
            <i data-icon-before="" className="mobile-back-icon"></i>
            {mobileBreadcrumbs.reverse().map((breadcrumb, index) => (
              <WvLink
                to={localePath(`/${breadcrumb.path}`)}
                key={breadcrumb?.id + index}
              >
                {breadcrumb.name}
                <i data-icon-after=""></i>
              </WvLink>
            ))}
          </>
        ) : null}
      </div>
    </>
  );
};

export default WvBreadcrumbs;
